<script setup>
import ActiveWeb from '@/components/topic/active/index.vue'
import ActiveMobile from '@/components/topic/activeMobile/index.vue'
const IS_Mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|HarmonyOS|OpenHarmony/i.test(navigator.userAgent);
const IS_H5 = IS_Mobile || window.innerWidth <= 768;
</script>

<template>
  <div>
    <!-- /* 判读是从哪个入口进入 */ -->
    <ActiveMobile v-if="IS_H5" />
    <ActiveWeb v-else />
  </div>
</template>

<style scoped>
@font-face {
  font-family: 'TypeRegular';
  src: url('@/fontFamily/360shouhuType-Regular.otf');
}
</style>
